import { Tooltip } from '@mui/material';
import {
  GOOGLE_VOLUME_LANGUAGES,
  volumeLabel,
  volumeWeight,
  type QueryVolume,
} from '../../../api/src/fakes/query-volume';
import { Typography } from './mui-system';
export function QueryVolumeLabel({ volume }: { volume?: QueryVolume }) {
  const detail =
    volume?.status === 'complete'
      ? volume.source === 'google_ads'
        ? `Google Ads · среднее за 12 месяцев · ${volume.regionName} · ${volume.google ? GOOGLE_VOLUME_LANGUAGES[volume.google.languageId] : ''} · все устройства · получено ${new Date(volume.capturedAt!).toLocaleDateString('ru-RU')}. Близкие варианты: ${volume.google?.sharedQueries.join(', ') ?? volume.phrase}. Вес площади: ${volumeWeight(volume).toLocaleString('ru-RU', { maximumFractionDigits: 2 })}; общий объём делится поровну между фразами текущего среза: ${(volume.weightQueries ?? volume.google?.sharedQueries ?? []).join(', ')}. В истории используется состав запуска.${volume.google?.monthlySearchVolumes.length ? ` Месяцы в ответе: ${volume.google.monthlySearchVolumes[0]!.month} — ${volume.google.monthlySearchVolumes.at(-1)!.month}.` : ''}`
        : `Яндекс Wordstat · точная частотность · ${volume.phrase} · ${volume.regionName} · ${volume.device === 'desktop' ? 'компьютеры' : 'телефоны'} · последние 30 дней на ${new Date(volume.capturedAt!).toLocaleDateString('ru-RU')}`
      : 'Частотность обновляется отдельно от выдачи, в разделе «Частотность».';
  const sharedDetail =
    volume?.wordstat && volume.wordstat.sharedQueries.length > 1
      ? ` Перестановки слов: ${volume.wordstat.sharedQueries.join(', ')}. Общий объём делится поровну между активными фразами (в истории — фразами запуска). Вес площади: ${volumeWeight(volume).toLocaleString('ru-RU', { maximumFractionDigits: 2 })}.`
      : '';
  const refresh = volume?.refresh;
  const refreshDetail = refresh
    ? ` Последняя попытка: ${new Date(refresh.requestedAt).toLocaleString('ru-RU')}.${refresh.error ? ` ${refresh.error}` : ''}`
    : '';
  return (
    <Tooltip
      title={`${detail}${sharedDetail}${refreshDetail}${volume?.weightUnavailableReason ? ` ${volume.weightUnavailableReason}` : ''}`}
    >
      <Typography component="span" display="block" fontSize={11} color="text.secondary">
        {volumeLabel(volume)}
      </Typography>
    </Tooltip>
  );
}
